// src/components/RatingModal.js — extracted from App.js
import React, { useState } from "react";
import { supabase } from "../lib/supabase";
import { upsertOne } from "../lib/supabase";

// ─── Rating Modal ─────────────────────────────────────────────────────────────
export function RatingModal({ target, requests, saveRequests, reviews, saveReviews, sellers, saveSellers, session, toast, onClose }) {
  const [stars, setStars] = useState(0);
  const [hovered, setHovered] = useState(0);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!stars) return;
    setSaving(true);
    const review = {
      id: "rv-" + Date.now(),
      requestId: target.requestId,
      fromUserId: session.user.id,
      fromRole: target.fromRole,
      toUserId: target.toUserId || null,
      toSellerId: target.toSellerId || null,
      rating: stars,
      review: text.trim(),
      createdAt: new Date().toISOString(),
    };
    const updatedReviews = [...(reviews||[]), review];
    saveReviews(updatedReviews);
    // Mark the request as rated by this side
    const ratedField = target.fromRole === "buyer" ? "buyerRated" : "sellerRated";
    saveRequests(requests.map(r => r.id !== target.requestId ? r : {...r, [ratedField]: true}));
    // Update seller's rolling average rating — targeted update (not bulk upsert)
    if (target.fromRole === "buyer" && target.toSellerId && saveSellers && sellers) {
      const sellerReviews = updatedReviews.filter(rv => rv.toSellerId === target.toSellerId && rv.fromRole === "buyer");
      const avg = sellerReviews.reduce((s,rv)=>s+rv.rating,0) / sellerReviews.length;
      const ratingPatch = { rating: Math.round(avg*10)/10, reviewCount: sellerReviews.length };
      await supabase.from("sellers").update(ratingPatch).eq("id", target.toSellerId);
      saveSellers(sellers.map(s => s.id !== target.toSellerId ? s : {...s, ...ratingPatch}));
    }
    setSaving(false);
    toast("Rating submitted — thank you.");
    onClose();
  };

  return (
    <div className="overlay" onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div className="modal fade-in" style={{maxWidth:400,padding:32}}>
        <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,marginBottom:4}}>Rate {target.toName}</div>
        <div style={{fontFamily:"'DM Mono',monospace",fontSize:10,color:"var(--ink3)",marginBottom:24}}>
          {target.fromRole==="buyer"?"How was your experience with this seller?":"How was this buyer to work with?"}
        </div>
        {/* Stars */}
        <div style={{display:"flex",gap:8,marginBottom:20}}>
          {[1,2,3,4,5].map(n=>(
            <span key={n} style={{fontSize:32,cursor:"pointer",color:(hovered||stars)>=n?"#D97706":"#D4D4D8",transition:"color 0.1s"}}
              onMouseEnter={()=>setHovered(n)} onMouseLeave={()=>setHovered(0)} onClick={()=>setStars(n)}>★</span>
          ))}
        </div>
        <textarea value={text} onChange={e=>setText(e.target.value)} placeholder="Leave a note (optional)…" rows={3} style={{marginBottom:20}} autoCapitalize="sentences"/>
        <div style={{display:"flex",gap:10}}>
          <button className="btn-ink" onClick={submit} disabled={!stars||saving} style={{flex:1,opacity:!stars?0.5:1}}>{saving?"Saving…":"Submit rating"}</button>
          <button className="btn-ghost" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// ─── Dispute Modal ─────────────────────────────────────────────────────────────
